"use strict";

exports.__esModule = true;
var _ScheduleListScreen = require("./ScheduleListScreen");
Object.keys(_ScheduleListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ScheduleListScreen[key]) return;
  exports[key] = _ScheduleListScreen[key];
});